const projectsData = [
  {
    year: "2024-2025",
    projects: [
      {
        id: 1,
        grade: "10-А",
        student: "Чупа Андрій",
        topic: "SmartBell - інтелектуальна система шкільних дзвінків",
        description: "Інноваційна розробка автоматизованої системи керування шкільними дзвінками через веб-інтерфейс. Система дозволяє гнучко налаштовувати розклад, додавати музичні мелодії та керувати сповіщеннями в реальному часі."
      }
    ]
  },
  {
    year: "2023-2024",
    teacher: "Хлопик Р. З.",
    projects: [
      {
        id: 2,
        grade: "10-А",
        student: "Пижик Арсен, Кравчук Вадим",
        topic: "Моделювання 3D об'єктів засобами програмного продукту Blender",
        description: "Дослідження можливостей сучасного 3D-моделювання. Створення деталізованих моделей об'єктів з використанням текстурування, освітлення та рендерингу в середовищі Blender."
      },
      {
        id: 3,
        grade: "10-Б",
        student: "Любченко Арсеній, Багній Ростислав",
        topic: "Розробка web-додатків використанням технологій Figma, HTML, CSS, JS, React",
        description: "Повний цикл розробки сучасного веб-інтерфейсу: від проектування дизайну у Figma до програмної реалізації на стеку React. Додаток має адаптивну верстку та інтерактивні елементи."
      },
      {
        id: 4,
        grade: "10-А",
        student: "Гула Максим",
        topic: "Штучний інтелект у нашому житті",
        description: "Аналіз сучасних трендів у галузі ШІ, дослідження роботи нейронних мереж та їх практичного застосування для автоматизації повсякденних завдань."
      }
    ]
  },
  {
    year: "2019-2020",
    projects: [
      {
        id: 5,
        student: "Чернявська В.",
        topic: "Кібератаки",
        description: "Класифікація сучасних кіберзагроз, аналіз методів захисту персональних даних та стратегії протидії поширеним видам атак у мережі."
      }
    ]
  },
  {
    year: "2018-2019",
    projects: [
      {
        id: 6,
        student: "Кіліян М.",
        topic: "Створення комп'ютерної гри на JavaScript",
        description: "Розробка інтерактивної браузерної гри з використанням Canvas API та чистого JavaScript. Реалізація ігрової логіки, фізики рухів та системи підрахунку очок."
      }
    ]
  },
  {
    year: "2017-2018",
    projects: [
      {
        id: 7,
        student: "Панчак О.",
        topic: "Darknet",
        description: "Дослідження прихованого сегменту мережі Інтернет, принципів роботи анонімних мереж (Tor) та етичних аспектів цифрової безпеки."
      }
    ]
  },
  {
    year: "2016-2017",
    projects: [
      {
        id: 8,
        student: "Панчак О.",
        topic: "Хакерські атаки",
        description: "Аналіз вразливостей інформаційних систем, історія найвідоміших зламів та розвиток сучасних технологій мережевого захисту."
      }
    ]
  },
  {
    year: "2015-2016",
    projects: [
      {
        id: 9,
        student: "Зубрицький М.",
        topic: "Інтернет - добро чи зло",
        description: "Комплексне дослідження впливу глобальної мережі на суспільство, психологічні аспекти залежності та можливості для саморозвитку та освіти."
      }
    ]
  },
  {
    year: "2014-2015",
    projects: [
      {
        id: 10,
        student: "Зубрицький М.",
        topic: "База даних шкільної бібліотеки",
        description: "Проектування та реалізація реляційної бази даних для автоматизації обліку книг, контролю видачі літератури та зручного пошуку в бібліотечному фонді."
      }
    ]
  },
  {
    year: "2013-2014",
    projects: [
      {
        id: 11,
        student: "Думало В.",
        topic: "3-Д модель школи",
        description: "Створення віртуальної архітектурної моделі будівлі закладу освіти з деталізацією внутрішніх приміщень та екстер'єру."
      }
    ]
  }
];

export default projectsData;
